import { atom } from 'jotai';

export const generateQuestionPaywallAtom = atom(false);
